import React from 'react';
import Select from 'react-select';
import { SelectFieldProps } from './types';

const SelectField: React.FC<SelectFieldProps> = ({
  id,
  label,
  value,
  onChange,
  disabled = false,
  required = false,
  onFocus,
  onBlur,
  hasValue,
  getFloatingLabelStyle,
  getFloatingInputStyle,
  styles,
  options,
}) => {
  const selectOptions = options.map(option => ({
    value: option.value,
    label: option.label,
  }));
  const selectedOption = selectOptions.find(opt => opt.value === value) || null;

  return (
    <div style={styles.floatingFieldContainer}>
      <Select
        inputId={id}
        value={selectedOption}
        onChange={opt => onChange?.(opt ? opt.value : '')}
        options={selectOptions}
        isDisabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder="Select..."
        menuPortalTarget={document.body}
        styles={{
          control: base => ({ ...base, ...getFloatingInputStyle(false, id) }),
          menuPortal: base => ({ ...base, zIndex: 10001 }),
        }}
      />
      <label htmlFor={id} style={getFloatingLabelStyle(id, hasValue)}>
        {label}
        {required && <span style={{ color: 'red' }}>*</span>}
      </label>
    </div>
  );
};

export default React.memo(SelectField);
